import React from "react";
import styled from "styled-components";
import { Button as AIMEButton } from "tot-loft-component-library";

function DeleteModal({ onClose, onDelete, itemName = "item" }) {
  return (
    <ContentWrapper>
      <ModalHeaderWrapper>
        <Title>Are you sure ?</Title>
        <Message>Do you want to remove this {itemName}?</Message>
      </ModalHeaderWrapper>
      <ButtonRow>
        <AIMEButton
          size="small"
          onClick={onClose}
          sx={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "row",
            alignItems: "center",
            flex: "none",
            borderRadius: "999px",
            background: "rgb(241, 245, 249)",
            backgroundRepeat: "no-repeat",
            backgroundSize: "contain",
            backgroundPosition: "center",
            boxSizing: "border-box",
            padding: "16px 32px",
          }}
        >
          <span
            style={{
              color: "rgb(33, 37, 67)",
              textOverflow: "ellipsis",
              fontSize: "16px",
              fontFamily: "Montserrat, sans-serif",
              fontWeight: "600",
              lineHeight: "110%",
              textAlign: "left",
            }}
          >
            Go Back
          </span>
        </AIMEButton>

        <AIMEButton
          size="small"
          onClick={onDelete}
          sx={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "row",
            alignItems: "center",
            flex: "none",
            gap: "10px",
            borderRadius: "48px",
            width: "157px",
            background: "rgba(223, 63, 63, 1)",
            backgroundRepeat: "no-repeat",
            backgroundSize: "contain",
            backgroundPosition: "center",
            boxSizing: "border-box",
            padding: "16px 32px",
            "&:hover": {
              background: "rgba(223, 63, 63, 1)",
              opacity: "0.9",
            },
          }}
        >
          <span
            style={{
              color: "white",
              textOverflow: "ellipsis",
              fontSize: "16px",
              fontFamily: "Montserrat, sans-serif",
              fontWeight: "600",
              lineHeight: "110%",
              textAlign: "left",
            }}
          >
            Remove
          </span>
        </AIMEButton>
      </ButtonRow>
    </ContentWrapper>
  );
}

export default DeleteModal;

const ContentWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: none;
  padding: 40px 24px 24px;
  box-sizing: border-box;
  width: 534px;
  gap: 8px;
`;
const ModalHeaderWrapper = styled.div`
  width: 486;
  height: 91;
  gap: 8px;
  padding-bottom: 24px;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: none;
`;

const Title = styled.h2`
  font-weight: 700;
  font-size: 30px;
  line-height: 100%;
  letter-spacing: -1%;
  color: var(--Color-Text-Text, rgba(33, 37, 67, 1));
   font-family: "Montserrat", sans-serif;
`;

const Message = styled.p`
  font-weight: 500;
  font-size: 14px;
  line-height: 160%;
  letter-spacing: 0%;
  vertical-align: middle;
  color: var(--Color-Text-Text, rgba(33, 37, 67, 1));
   font-family: "Montserrat", sans-serif;
`;

const ButtonRow = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  width: 100%;
`;
